import { library } from "@fortawesome/fontawesome-svg-core";
import { 
  faFacebook, 
  faXTwitter,
  faTwitter,
  faLinkedin, 
  faInstagram,
  faTiktok, 
  faSnapchat, 
  faVimeo, 
  faYoutube
} from "@fortawesome/free-brands-svg-icons";

import "font-awesome/css/font-awesome.css";

library.add(
  faTwitter,
  faFacebook, 
  faXTwitter, 
  faLinkedin, 
  faInstagram,
  faTiktok, 
  faSnapchat, 
  faVimeo, 
  faYoutube
);
